module.exports = __webpack_public_path__ + "img/Code_Notifications_Screenshot_iphone13.acaa8702.png";